import { render, staticRenderFns } from "./FormMarketplace.vue?vue&type=template&id=e85cd62e&scoped=true"
import script from "./FormMarketplace.vue?vue&type=script&lang=js"
export * from "./FormMarketplace.vue?vue&type=script&lang=js"
import style0 from "./FormMarketplace.vue?vue&type=style&index=0&id=e85cd62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85cd62e",
  null
  
)

export default component.exports